import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { CollectionArrow } from 'atoms/icons/CollectionArrow';
import { Horizontal } from 'atoms/layout/flex';
import { Skeleton } from 'atoms/loader/Skeleton';
import { LabelM, LabelS } from 'atoms/typography';
import { SplitProgressBar as DumbSplitProgressBar } from 'atoms/ui/SplitProgressBar';

import {
  SplitProgressBar_cardCollection,
  SplitProgressBar_userCardCollection,
} from './__generated__/index.graphql';

const ShinyText = styled.span`
  color: var(--c-yellow-200);
  text-shadow: 0px 1px 7px var(--c-yellow-400);
`;
const ArrowWrapper = styled(Horizontal).attrs({ center: true })`
  color: var(--c-yellow-200);
`;

type Props = {
  cardCollection: Nullable<SplitProgressBar_cardCollection>;
  userCardCollection: Nullable<SplitProgressBar_userCardCollection>;
  scoreIncrease?: number;
  withoutLabel?: boolean;
};
export const SplitProgressBar = ({
  cardCollection,
  userCardCollection,
  scoreIncrease = 0,
  withoutLabel,
}: Props) => {
  const { bonusThresholds } = cardCollection || {};
  const { score = 0, bonus = 0 } = userCardCollection || {};

  return (
    <Skeleton loading={!bonusThresholds?.length}>
      <DumbSplitProgressBar
        glow
        thresholds={
          bonusThresholds?.map(bonusThreshold => ({
            score: bonusThreshold.threshold,
          })) || []
        }
        currentScore={score}
        previewScore={score + scoreIncrease}
        color="var(--c-yellow-400)"
        {...(!withoutLabel && {
          label: (
            <Horizontal gap={0.5}>
              <ArrowWrapper>
                <CollectionArrow shiny />
              </ArrowWrapper>
              <ShinyText>
                <LabelM bold as="span">
                  +{bonus * 100}
                </LabelM>
                <LabelS as="span">%</LabelS>
              </ShinyText>
            </Horizontal>
          ),
        })}
      />
    </Skeleton>
  );
};

SplitProgressBar.fragments = {
  cardCollection: gql`
    fragment SplitProgressBar_cardCollection on CardCollection {
      slug
      bonusThresholds {
        threshold
      }
    }
  ` as TypedDocumentNode<SplitProgressBar_cardCollection>,
  userCardCollection: gql`
    fragment SplitProgressBar_userCardCollection on UserCardCollection {
      id
      score
      bonus
    }
  ` as TypedDocumentNode<SplitProgressBar_userCardCollection>,
};
